import { create } from "zustand";
import { ViewWLSubscriptionsTiers } from "../../../Common/models/subscriptions";

interface UserSubscriptionState {
  subscriptionList: null | ViewWLSubscriptionsTiers[];
  setSubscriptionList: (state: ViewWLSubscriptionsTiers[]) => void;

  powerUpList: null | ViewWLSubscriptionsTiers[];
  setPowerUpList: (state: ViewWLSubscriptionsTiers[]) => void;

  resetStore: () => void;
}

const useUserSubscriptionsStore = create<UserSubscriptionState>((set) => ({
  subscriptionList: null,
  setSubscriptionList: (subscriptionList) => set({ subscriptionList }),

  powerUpList: null,
  setPowerUpList: (powerUpList) => set({ powerUpList }),

  resetStore: () => {
    return set({
      subscriptionList: null,
      powerUpList: null,
    });
  },
}));

export default useUserSubscriptionsStore;
